export interface DashboardTypeState {
    meterDashboard: boolean;
    portfolio: boolean;
    locationId?: string;
}

export function resolveDashboardTypeState(dashboardType?: string): DashboardTypeState | null {
    if (!dashboardType) return null;
    return {
        meterDashboard: dashboardType === 'meter',
        portfolio: dashboardType === 'portfolio',
        locationId: dashboardType !== 'meter' && dashboardType !== 'portfolio' ? dashboardType : undefined
    };
}
